import { createTypedHooks } from 'easy-peasy';
import { IStoreModel } from '@seller-hermes/store/root.store';

const typedHooks = createTypedHooks<IStoreModel>();

export const useStoreActions = typedHooks.useStoreActions;
export const useStoreDispatch = typedHooks.useStoreDispatch;
export const useStoreState = typedHooks.useStoreState;
